<div class="flex-container">
  <iframe [src]="dashboardUrl()"></iframe>
</div>
